var _a;
export var Theme;
(function (Theme) {
    Theme["LIGHT_CLASSIC"] = "Light Classic";
    Theme["DARK_CLASSIC"] = "Dark Classic";
    Theme["LIGHT_MODERN"] = "Light Modern";
})(Theme || (Theme = {}));
export var modeForMUI = (_a = {},
    _a[Theme.LIGHT_CLASSIC] = 'light',
    _a[Theme.DARK_CLASSIC] = 'dark',
    _a[Theme.LIGHT_MODERN] = 'light',
    _a);
